/** Dummy web version for debugging */
const dialNumber = async (number: string): Promise<void> =>
  alert('Dialled Number: ' + number);

export const openPhone = () => alert('Opened Phone');

export default dialNumber
